// generated from 2_273_333 samples

import { z } from "zod";
import { common } from "../common";
import { stepGetBaseSchema } from "./stepGetBaseSchema";
import { attachedImageSchema } from "../shared/attachedImageSchema";
import { sparseSegmentSchema } from "../shared/sparseSegmentSchema";
import { orBehaviorTriggerGetSchema } from "../trigger/orBehaviorTriggerGetSchema";
import { triggerGetSchema } from "../trigger/triggerGetSchema";
import { messageGetSchema } from "../message/messageGetSchema";
import { audienceDescriptionHashSchema } from "../shared/audienceDescriptionHashSchema";
import { filtersGetSchema, exclusionFiltersGetSchema } from "../filter/filtersGetSchema";
import { componentStoreSchema } from "../shared/componentStoreSchema";

export const fullStepGetSchema = z.object({
  ...stepGetBaseSchema.shape,
  type: z.literal("FULL"),
  step_data: z.never().optional(),
  attached_images: z.array(attachedImageSchema),
  // Content Optimization steps include component_store
  component_store: componentStoreSchema.nullable().optional(),
  audience_description: z.string(),
  audience_description_hash: audienceDescriptionHashSchema,
  composition_mode: z.enum([
    "per-variation", // 1_748_534 (76.91%)
    "quick-push-multichannel", // 524_799 (23.09%)
  ]),
  // null: 2_140_550 (94.16%)
  content_card_delivery_control: z
    .enum([
      "just_in_time", // 87_191 (65.66%)
      "time_based", // 45_592 (34.34%)
    ])
    .nullable(),
  exclusion_filters: exclusionFiltersGetSchema,
  filters: filtersGetSchema,
  // null: 85_999 (3.78%)
  // true 2_122_532 (97.04%), false 64_802 (2.96%)
  forced_advancement_behavior: z.boolean().nullable(),
  delivery_validation_failure_behavior: z.enum(["exit", "advance"]).nullable().optional(),
  // null: 90_695 (3.99%)
  // true 50_246 (2.30%), false 2_132_392 (97.70%)
  ignore_workflow_quiet_time: z.boolean().nullable(),
  // null: 2_237_192 (98.41%)
  ip_pool: z.string().nullable(),
  // null: 9_208 (0.41%)
  // true 69_547 (3.07%), false 2_194_578 (96.93%)
  is_control_step: z.boolean().nullable(),
  last_edit: z.object({
    // undefined: 270_463 (11.90%), defined 2_002_870 (88.10%)
    // format object-id: 1_832_287 (91.48%)
    d_id: z.string().optional(),
    name: z.string(),
    // avg: 1731730931.87, min: 1464044126, max: 1749566774
    time: z.int().nonnegative(),
  }),
  messaging_actions: z.array(messageGetSchema),
  // null: 191_512 (8.42%)
  ms_id: common.objectId.nullable(),
  // null: 2_079_104 (91.46%)
  // avg: 3.79, min: 0, max: 90
  priority: z.int().min(0).nullable(),
  // true 11_680 (0.51%), false 2_261_653 (99.49%)
  push_max_enabled: z.boolean(),
  rate_limit_alert_data: z.object({
    // null: 2_271_870 (99.94%)
    aborted_due_to_rate_limit: z.literal(true).nullable(),
    // null: 2_267_022 (99.72%)
    rate_limit_alert: z.literal(true).nullable(),
  }),
  segments_data_array: z.array(sparseSegmentSchema),
  trigger_schedule_data: z
    .object({
      // undefined: 572 (0.03%), defined 2_272_761 (99.97%)
      check_eligibility_at_impression_time: z.literal(false).optional(),
      // undefined: 572 (0.03%), defined 2_272_761 (99.97%)
      // null: 16 (0.00%)
      delay_option: z
        .enum([
          "immediately", // 2_207_497 (97.13%)
          "after", // 60_759 (2.67%)
          "in", // 3_297 (0.15%)
          "on the next", // 1_192 (0.05%)
        ])
        .nullable()
        .optional(),
      // undefined: 572 (0.03%), defined 2_272_761 (99.97%)
      // null: 2_269_464 (99.85%)
      deliver_in_days: z.int().min(0).nullable().optional(),
      // null: 2_268_659 (99.79%)
      // true 3_485 (74.56%), false 1_189 (25.44%)
      deliver_in_local_time: z.boolean().nullable(),
      // undefined: 572 (0.03%), defined 2_272_761 (99.97%)
      // null: 2_271_569 (99.95%)
      delivery_day: z
        .enum(["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"])
        .nullable()
        .optional(),
      // undefined: 572 (0.03%), defined 2_272_761 (99.97%)
      // null: 2_268_646 (99.82%)
      delivery_time_without_zone: z
        .object({
          hour: z.int().min(0).max(23),
          min: z.int().min(0).max(59),
          sec: z.int().min(0).max(59),
        })
        .nullable()
        .optional(),
      // undefined: 572 (0.03%), defined 2_272_761 (99.97%)
      // null: 2_266_646 (99.73%)
      // avg: 264407.40, min: 0, max: 2678400
      duration_in_seconds: z.int().min(0).nullable().optional(),
      // undefined: 572 (0.03%), defined 2_272_761 (99.97%)
      // null: 2_270_657 (99.91%)
      // avg: 1733915763.17, min: 1493759700, max: 1772319300
      end_time: z.int().nonnegative().nullable().optional(),
      // undefined: 572 (0.03%), defined 2_272_761 (99.97%)
      // true 75_600 (3.33%), false 2_197_161 (96.67%)
      evaluate_segment_at_enqueue_time: z.boolean().optional(),
      // undefined: 572 (0.03%), defined 2_272_761 (99.97%)
      // null: 2_259_582 (99.42%)
      exception_event: z.union([orBehaviorTriggerGetSchema, triggerGetSchema]).nullable().optional(),
      optimal_time_default_data: z.object({
        // null: 96_715 (4.25%)
        // avg: 16.96, min: 0, max: 23
        optimal_time_default_hour: z.int().min(0).nullable(),
        // null: 96_715 (4.25%)
        // avg: 0.08, min: 0, max: 59
        optimal_time_default_minute: z.int().min(0).nullable(),
        // true 98_815 (4.35%), false 2_174_518 (95.65%)
        optimal_time_notification: z.boolean(),
        // null: 2_174_620 (95.66%)
        // true 75_107 (76.09%), false 23_606 (23.91%)
        use_app_group_best_time: z.boolean().nullable(),
      }),
      // true 98_815 (4.35%), false 2_174_518 (95.65%)
      optimal_time_notification: z.boolean(),
      // undefined: 572 (0.03%), defined 2_272_761 (99.97%)
      // true 2_197_176 (96.67%), false 75_585 (3.33%)
      reevaluate_segment_at_send_time: z.boolean().optional(),
      retry_window_seconds: z.int().min(0).optional(),
      // undefined: 572 (0.03%), defined 2_272_761 (99.97%)
      // null: 90_830 (4.00%)
      send_after_quiet_time: z.literal(false).nullable().optional(),
      // undefined: 572 (0.03%), defined 2_272_761 (99.97%)
      // avg: 1707042130.32, min: 0, max: 1809624600
      start_time: z.int().min(0).optional(),
      // undefined: 572 (0.03%), defined 2_272_761 (99.97%)
      // null: 4_505 (0.20%)
      // avg: 10248.96, min: 0, max: 11545632000
      trigger_delay_in_seconds: z.int().min(0).nullable().optional(),
      // undefined: 572 (0.03%), defined 2_272_761 (99.97%)
      // null: 56_284 (2.48%)
      trigger_event: z.union([orBehaviorTriggerGetSchema, triggerGetSchema]).nullable().optional(),
    })
    .partial(),
  // undefined: 1_431_403 (62.96%), defined 841_930 (37.04%)
  // null: 445_579 (52.92%)
  // true 3_399 (0.86%), false 392_952 (99.14%)
  using_v2_filters: z.boolean().nullable().optional(),
});
